import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const images = [];

  // Remove list
  const removeList = [108,111,73];

  // Existing photo1 - photo25
  for (let i = 1; i <= 83; i++) {
    if (!removeList.includes(i)) {
      images.push(`${process.env.PUBLIC_URL}/images/photo${i}.jpeg`);
    }
  }

  for (let i = 84; i <= 164; i++) {
    if (!removeList.includes(i)) {
      images.push(`${process.env.PUBLIC_URL}/images/photo${i}.jpg`);
    }
  }
  // // mam1 - mam11
  // for (let i = 1; i <= 11; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/mam${i}.jpeg`);
  // }

  // // a1 - a8
  // for (let i = 1; i <= 8; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/a${i}.png`);
  // }

  // // as1 - as5
  // for (let i = 1; i <= 5; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/as${i}.png`);
  // }

  // // dm1 - dm5
  // for (let i = 1; i <= 5; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/dm${i}.png`);
  // }

  // // gm1 - gm4
  // for (let i = 1; i <= 4; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/gm${i}.png`);
  // }

  // // gp1 - gp6
  // for (let i = 1; i <= 6; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/gp${i}.png`);
  // }

  // // gr1 - gr2
  // for (let i = 1; i <= 2; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/gr${i}.png`);
  // }

  // // m1 - m5
  // for (let i = 1; i <= 5; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/m${i}.png`);
  // }

  // // rd1 - rd3
  // for (let i = 1; i <= 3; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/rd${i}.png`);
  // }

  // // zp1 - zp8
  // for (let i = 1; i <= 12; i++) {
  //   images.push(`${process.env.PUBLIC_URL}/images/zp${i}.png`);
  // }

   const handleClick = (index) => {
     setActiveIndex(index === activeIndex ? null : index);
  };

  return (
     


    
  <div className="gallery-container">

   

    {/* IMAGE GALLERY SECTION */}
    <h2 className="gallery-title">📸 गावाचा विकास – छायाचित्रांतून</h2>

    <div className="gallery-grid">
      {images.map((src, index) => (
        <div
          className={`gallery-card ${activeIndex === index ? "active" : ""}`}
          key={index}
          onClick={() => handleClick(index)}
        >
          <img
            src={src}
            alt={`Gallery Photo ${index + 1}`}
            className="gallery-img"
          />
        </div>
      ))}
    </div>
  </div>
);


  
};



export default Gallery;


